import { IndicatorProjectSaveRequestDto } from '../dto/request/indicator-project-save-request.dto';
import { IndicatorProjectUpdateRequestDto } from '../dto/request/indicator-project-update-request.dto';
import { IndicatorProjectResponseDto } from '../dto/response/indicator-project-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class IndicatorProjectService extends BaseLandscapeService {
  public async fetchIndicatorProjectById(
    id: string
  ): Promise<IndicatorProjectResponseDto> {
    const response = await this.get<IndicatorProjectResponseDto>(
      `/indicatorproject/${id}`
    );
    return response.data;
  }

  public async fetchIndicatorProjectsByProjectId(
    projectId: string
  ): Promise<IndicatorProjectResponseDto[]> {
    const response = await this.get<IndicatorProjectResponseDto[]>(
      `/indicatorproject/getcompactindicatoridsbyprojectid/${projectId}`
    );
    return response.data;
  }

  public async fetchIndicatorProjectsByCompactIndicatorId(
    compactIndicatorId: string
  ): Promise<IndicatorProjectResponseDto[]> {
    const response = await this.get<IndicatorProjectResponseDto[]>(
      `/indicatorproject/getprojectsbycompactindicatorid/${compactIndicatorId}`
    );
    return response.data;
  }

  public async saveIndicatorProject(
    saveRequest: IndicatorProjectSaveRequestDto
  ): Promise<IndicatorProjectResponseDto> {
    const response = await this.post<IndicatorProjectResponseDto>(
      `/indicatorproject`,
      saveRequest
    );
    return response.data;
  }

  public async updateIndicatorProject(
    updateRequest: IndicatorProjectUpdateRequestDto
  ): Promise<IndicatorProjectResponseDto> {
    const response = await this.put<IndicatorProjectResponseDto>(
      `/indicatorproject`,
      updateRequest
    );
    return response.data;
  }

  public async deleteIndicatorProject(existingId: string): Promise<void> {
    await this.delete<void>(`/indicatorproject/${existingId}`);
  }
}

const indicatorProjectService = new IndicatorProjectService();
export default indicatorProjectService;
